export const RoutePath = {
  login: "/login",
  register: "/register",
  dashboard: "/",
  inspection: "/inspection",
  forgot: "/forgot-password",
  services: "/services",
  payments: "/payments",
  criminalCheck: "/criminal",
  myChecks: "/myChecks",
  viewOrder: "/viewOrder",
  fingerPrintPayment: "/fingerprintPayment",
};
